import {
  TURNO_SALDADO_ERROR,
  TURNO_SALDADO_LOADING,
  TURNO_SALDADO_RESET,
  TURNO_SALDADO_SUCCESS,
} from "_+_Portal/context/ActionTypes";
import axiosInstance from "global/helpers/axiosInstance";

export const wsGetTurnoSaldado = (idTurno, nextStep) => (dispatch) => {
  dispatch({
    type: TURNO_SALDADO_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/turno/getSaldado/${idTurno}`)
      .then((res) => {
        dispatch({
          type: TURNO_SALDADO_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };
        dispatch({
          type: TURNO_SALDADO_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, err.data);
      });
  });
};
export const wsGetTurnoSaldadoLabo = (idProtocolo, nextStep) => (dispatch) => {
  dispatch({
    type: TURNO_SALDADO_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/laboratorio/getSaldado/${idProtocolo}`)
      .then((res) => {
        dispatch({
          type: TURNO_SALDADO_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };
        dispatch({
          type: TURNO_SALDADO_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, err.data);
      });
  });
};

export const turnoSaldadoReset = () => (dispatch) => {
  dispatch({
    type: TURNO_SALDADO_RESET,
  });
};
